export function millisecondsToSeconds(milliseconds) {
    return milliseconds / 1000;
}
//# sourceMappingURL=time.js.map